import {Base} from './base.model';
import { DatePipe } from '@angular/common';

export class RangeNDC extends Base{
	id: string;
	termCountry: string;
	dataSource: string;
	dialPattern: string;
	dialPatternType: "Prime" | "Prime-1" | "Prime-2" | "Prime-3" | "Prime-4";
	ccNdc: string;
	iso2: string;
	code: string;
	tos: string;
	tosdesc: string;
	ndc: string;
	locality: string;
	provider: string;
	supplement: string;
	effectiveDate: Date;
	lemin:number;
	lemax:number;

	//add for download
	prime: string;
	primeMinus1: string;
	primeMinus2: string;
	primeMinus3: string;
	primeMinus4: string;
	// lastUpdate: string;
	firstSeen: string;
	lastSeen: string;

	static toString(r:RangeNDC,  delimiter: string): string {
		let result = [];

    	result.push(r.termCountry);

		if (r.prime || r.primeMinus1 || r.primeMinus2 || r.primeMinus3 || r.primeMinus4) {
			result.push(r.prime);
			result.push(r.primeMinus1);
			result.push(r.primeMinus2);
			result.push(r.primeMinus3);
			result.push(r.primeMinus4);
		}
		result.push(r.code);
		result.push(r.iso2);
		result.push(r.tos);
		result.push(r.tosdesc);
		result.push(r.ndc);
		result.push(r.provider);
		result.push(r.supplement);
		result.push(r.lemin);
		result.push(r.lemax);

		if (r.primeMinus1 || r.primeMinus2 || r.primeMinus3 || r.primeMinus4) {
			// if (r.lastUpdate) {
			// 	result.push(r.lastUpdate.replace('-', ''));
			// } else {
			// 	result.push('');
			// }
			result.push(r.firstSeen ? r.firstSeen: '');
			result.push(r.lastSeen ? r.lastSeen: '');

		} else {
			if (r.effectiveDate) {
				result.push(new DatePipe('en-US').transform(r.effectiveDate, 'MM/dd/yyyy'));
			} else {
				result.push('');
			}    			
		}
		return result.join(delimiter);
	}

  toPartitionFormat(delimiter: string): string {
		let result = [];
		if (this.dataSource.startsWith('IPRN')) {
			result.push('IPRN');
		} else {
			result.push(this.dataSource);
		}
		result.push(this.termCountry);
		result.push(this.dialPattern);
		result.push(this.dialPatternType);
		result.push(''); //customer date
		result.push('');   //reason
		result.push('');   //note
		result.push(this.code);
		result.push(this.iso2);
		result.push(this.tos);
		result.push(this.tosdesc);
		result.push(this.ndc);
		result.push(this.provider);
		result.push(this.supplement);
		result.push(this.lemin);
		result.push(this.lemax);
	    return result.join(delimiter);
  }
}

